import axiosInstance from 'api/axios';
import { lifeCycleInputs } from '../types/apiRequest';
import { lifeCycleResponse } from '../types/apiResponses';

const lifeCycleApiSerivces = {
  startBot: async (data: lifeCycleInputs): Promise<lifeCycleResponse> => {
    const response = await axiosInstance.private.post(
      '/api/v1/tele/start',
      data
    );

    return response.data;
  },
  stopBot: async (
    data: lifeCycleInputs
  ): Promise<{ success: boolean; message: { message: string } }> => {
    const response = await axiosInstance.private.post(
      '/api/v1/tele/stop',
      data
    );

    return response.data;
  },
  restartBot: async (data: lifeCycleInputs): Promise<lifeCycleResponse> => {
    const response = await axiosInstance.private.post(
      '/api/v1/tele/restart',
      data
    );

    return response.data;
  },
};

export default lifeCycleApiSerivces